/**
 * Mapping of routes to components and teams for the CP app
 */
const teamComponentMapCp = [
  {
    pattern: "/",
    team: "cp",
    component: "root"
  },
  {
    pattern: "/ory-login",
    team: "cp",
    component: "ory-login"
  },
  {
    pattern: "/client_login",
    team: "cp",
    component: "login-redirect"
  },
  {
    pattern: "/private_browsing",
    team: "cp",
    component: "login-private-browsing"
  },
  {
    pattern: "/login",
    team: "cp",
    component: "login-container-login"
  },
  {
    pattern: "/link_sent",
    team: "cp",
    component: "login-resend-magic-link"
  },
  {
    pattern: "/link_expired",
    team: "cp",
    component: "login-send-magic-link-exp"
  },
  {
    pattern: "/confirm_user",
    team: "cp",
    component: "login-user-disambiguation"
  },
  {
    pattern: "/confirm_case",
    team: "cp",
    component: "login-case-disambiguation"
  },
  {
    pattern: "/verify_idd",
    team: "cp",
    component: "login-verify-idd"
  },
  {
    pattern: "/login_error",
    team: "cp",
    component: "login-error"
  },
  {
    pattern: "/denied_access",
    team: "cp",
    component: "login-denied-access"
  },
  {
    pattern: "/client_error",
    team: "cp",
    component: "login-client-error"
  },
  {
    pattern: "/verification",
    team: "cp",
    component: "ory-verification"
  },
  {
    pattern: "/email_recovery",
    team: "cp",
    component: "ory-email-verification"
  },
  {
    pattern: "/password",
    team: "cp",
    component: "ory-password"
  },
  {
    pattern: "/settings",
    team: "cp",
    component: "ory-create-password"
  },
  {
    pattern: "/phone_selection",
    team: "cp",
    component: "ory-phone-selection"
  },
  {
    pattern: "/no_invite",
    team: "cp",
    component: "ory-no-invite"
  },
  {
    pattern: "/flow-expired",
    team: "cp",
    component: "flow-expired"
  },
  {
    pattern: "/dashboard",
    team: "cp",
    component: "dashboard"
  },
  {
    pattern: "/*/dashboard",
    team: "cp",
    component: "dashboard"
  },
  {
    pattern: "/survey",
    team: "cp",
    component: "survey"
  },
  {
    pattern: "/cases-dashboard",
    team: "cp",
    component: "dashboard"
  },
  {
    pattern: "/schedule_appointment",
    team: "cp",
    component: "schedule-appointment"
  },
  {
    pattern: "/*/schedule_appointment",
    team: "cp",
    component: "schedule-appointment-direct"
  },
  {
    pattern: "/messages",
    team: "cp",
    component: "secure-messaging"
  },
  {
    pattern: "/messages/*",
    team: "cp",
    component: "secure-messaging"
  },
  {
    pattern: "/chats",
    team: "cp",
    component: "secure-messaging-v3"
  },
  {
    pattern: "/chats/*",
    team: "cp",
    component: "secure-messaging-v3"
  },
  {
    pattern: "/documents/*",
    team: "cp",
    component: "document-case-view"
  },
  {
    pattern: "/documents/*/preview/*",
    team: "cp",
    component: "document-case-view"
  },
  {
    pattern: "/documents/preview/*",
    team: "cp",
    component: "document-case-view"
  },
  {
    pattern: "/client_documents/*",
    team: "cp",
    component: "document-client-view"
  },
  {
    pattern: "/client_documents/*/preview/*",
    team: "cp",
    component: "document-client-view"
  },
  {
    pattern: "/documents",
    team: "cp",
    component: "documents-dashboard"
  },
  {
    pattern: "/document-upload/income",
    team: "cp",
    component: "document-upload-proof-of-income"
  },
  {
    pattern: "/document-upload/banking",
    team: "cp",
    component: "document-upload-banking-statement"
  },
  {
    pattern: "/document-upload/address",
    team: "cp",
    component: "document-upload-proof-of-address"
  },
  {
    pattern: "/document-upload/other",
    team: "cp",
    component: "document-upload-additional-documents"
  },
  {
    pattern: "/document-upload",
    team: "cp",
    component: "document-upload"
  },
  {
    pattern: "/*/document-upload/income",
    team: "cp",
    component: "document-upload-proof-of-income-3"
  },
  {
    pattern: "/*/document-upload/banking",
    team: "cp",
    component: "document-upload-banking-statement-3"
  },
  {
    pattern: "/*/document-upload/address",
    team: "cp",
    component: "document-upload-proof-of-address-3"
  },
  {
    pattern: "/*/document-upload/other",
    team: "cp",
    component: "document-upload-additional-documents-3"
  },
  {
    pattern: "/*/document-upload",
    team: "cp",
    component: "document-upload-3"
  },
  {
    pattern: "/preview/*",
    team: "cp",
    component: "document-preview"
  },
  {
    pattern: "/onboarding/idd",
    team: "cp",
    component: "on-boarding-form-idd-screen"
  },
  {
    pattern: "/onboarding",
    team: "cp",
    component: "on-boarding-form"
  },
  {
    pattern: "/profile/*/personal",
    team: "cp",
    component: "profile-personal-information-form"
  },
  {
    pattern: "/profile/*/contacts",
    team: "cp",
    component: "profile-contact-information-form"
  },
  {
    pattern: "/profile/*/employment",
    team: "cp",
    component: "profile-employment-information-form"
  },
  {
    pattern: "/profile/*",
    team: "cp",
    component: "profile-profile-card"
  },
  {
    pattern: "/requirements/situation",
    team: "cp",
    component: "requirements-situation-form"
  },
  {
    pattern: "/requirements/property",
    team: "cp",
    component: "requirements-property"
  },
  {
    pattern: "/requirements/preferences",
    team: "cp",
    component: "requirements-preferences-form"
  },
  {
    pattern: "/requirements/conveyancer",
    team: "cp",
    component: "requirements-conveyancer-form"
  },
  {
    pattern: "/requirements/other-properties",
    team: "cp",
    component: "requirements-other-properties"
  },
  {
    pattern: "/requirements/committed-expenditure",
    team: "cp",
    component: "requirements-committed-expenditure"
  },
  {
    pattern: "/requirements/discretionary-expenditure",
    team: "cp",
    component: "requirements-discretionary-expenditure"
  },
  {
    pattern: "/requirements/protection/advice",
    team: "cp",
    component: "requirements-protection-form"
  },
  {
    pattern: "/requirements",
    team: "cp",
    component: "requirements-requirements-card"
  },
  {
    pattern: "/conveyancing/quote",
    team: "cp",
    component: "conveyancing-quote"
  },
  {
    pattern: "/conveyancing/fact-find/property",
    team: "cp",
    component: "conveyancing-fact-find-current-property"
  },
  {
    pattern: "/conveyancing/fact-find/new-property",
    team: "cp",
    component: "conveyancing-fact-find-new-property"
  },
  {
    pattern: "/conveyancing/fact-find/about",
    team: "cp",
    component: "conveyancing-fact-find-personal-info"
  },
  {
    pattern: "/conveyancing/fact-find/mortgage",
    team: "cp",
    component: "conveyancing-fact-find-mortgage-form"
  },
  {
    pattern: "/conveyancing/fact-find/completed",
    team: "cp",
    component: "conveyancing-fact-find-complete-section"
  },
  {
    pattern: "/conveyancing/fact-find",
    team: "cp",
    component: "conveyancing-fact-find"
  },
  {
    pattern: "/credit/overview",
    team: "cp",
    component: "credit-credit-overview"
  },
  {
    pattern: "/credit/disclosure",
    team: "cp",
    component: "credit-credit-report-idd"
  },
  {
    pattern: "/credit/security/terms-and-conditions",
    team: "cp",
    component: "credit-credit-report-idd-kba"
  },
  {
    pattern: "/credit/id-checks",
    team: "cp",
    component: "credit-identity"
  },
  {
    pattern: "/credit/id-checks/result",
    team: "cp",
    component: "credit-eidv"
  },
  {
    pattern: "/credit/security/questions",
    team: "cp",
    component: "credit-kba-questions"
  },
  {
    pattern: "/credit",
    team: "cp",
    component: "credit"
  },
  {
    pattern: "/properties",
    team: "cp",
    component: "property-list"
  },
  {
    pattern: "/properties/property-info/epc",
    team: "cp",
    component: "property-info-epc"
  },
  {
    pattern: "/properties/property-info",
    team: "cp",
    component: "property-info"
  },
  {
    pattern: "/properties/property-info/*/epc",
    team: "cp",
    component: "property-info-epc"
  },
  {
    pattern: "/properties/property-info/*",
    team: "cp",
    component: "property-info"
  },
  {
    pattern: "/homebuyers-checklist",
    team: "cp",
    component: "check-list-dashboard"
  },
  {
    pattern: "/credit-details",
    team: "cp",
    component: "credit-details"
  },
  {
    pattern: "/surveying",
    team: "cp",
    component: "surveying"
  },
  {
    pattern: "/wills",
    team: "cp",
    component: "wills"
  },
  {
    pattern: "/cases/*/dashboard",
    team: "cp",
    component: "cases-dashboard"
  },
  {
    pattern: "/go-cardless-payment-return",
    team: "cp",
    component: "payment-complete"
  },
  {
    pattern: "/go-cardless-payment-rejected",
    team: "cp",
    component: "payment-failed"
  },
  {
    pattern: "/tradesmen",
    team: "cp",
    component: "tradesmen"
  },
  {
    pattern: "/portal-settings",
    team: "cp",
    component: "data-preferences"
  },
  {
    pattern: "/portal-settings/credit",
    team: "cp",
    component: "credit-settings"
  },
  {
    pattern: "/portal-settings/preferences",
    team: "cp",
    component: "data-preferences"
  },
]

export default teamComponentMapCp
